import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuthContext } from "../../contexts/AuthContext/AuthProvider";

const ShopMenu = ({ onTrigger }) => {
    const { logout } = useAuthContext();
    const location = useLocation();
    const isFavoritesPage = location.pathname.includes("/ucp/shop/favorites");
    const isBuyPage = location.pathname.includes("/ucp/shop/buy");
    const showBackLink = isFavoritesPage || isBuyPage;
    const [open, setOpen] = useState(false);
    const [mounted, setMounted] = useState(false);

    const openSideMenu = () => {
        setMounted(true);
        requestAnimationFrame(() => setOpen(true));
    };

    const closeSideMenu = () => setOpen(false);

    useEffect(() => {
        if (onTrigger) onTrigger(openSideMenu);
    }, [onTrigger]);

    useEffect(() => {
        if (open) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);

    useEffect(() => {
        if (!open && mounted) {
            const t = setTimeout(() => setMounted(false), 360);
            return () => clearTimeout(t);
        }
    }, [open, mounted]);

    if (!mounted) return null;

    return (
        <div
            className={`side-menu-overlay ${open ? "open" : ""}`}
            role="dialog"
            aria-hidden={!open}
            onClick={closeSideMenu}
        >
            <aside className="side-menu" onClick={(e) => e.stopPropagation()}>
                <button
                    className="side-menu-button-close"
                    onClick={closeSideMenu}
                    aria-label="Закрыть"
                ></button>
                <div className="side-menu-list">
                    {showBackLink ? (
                        <a
                            href="/ucp/shop?category=main"
                            className="side-menu-text side-menu-text--with-back-arrow"
                        >
                            НАЗАД
                        </a>
                    ) : null}
                    <a href="/" onClick={logout} className="side-menu-text">
                        ГЛАВНАЯ
                    </a>
                    <a
                        href="/ucp"
                        className="side-menu-text side-menu-text--with-back-arrow"
                    >
                        ЛИЧНЫЙ КАБИНЕТ
                    </a>
                    <a href="/ucp/shop/favorites" className="side-menu-text">
                        ИЗБРАННОЕ
                    </a>
                </div>
                <div className="side-menu-social-icons-container">
                    <a
                        href="https://vk.com/medievalrpnet"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <button className="vk-icon" aria-label="vk"></button>
                    </a>
                    <a
                        href="https://t.me/medieval_rp"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <button
                            className="telegram-icon"
                            aria-label="tg"
                        ></button>
                    </a>
                </div>
            </aside>
        </div>
    );
};

export default ShopMenu;
export { ShopMenu };
